export const advantagesData = [
	{
		id: 1,
		icon: '',
		title: 'Денежный приз',
		text: 'Победители каждой номинации получат денежные призы. Призовой фонд конкурса – 1\u00A0000\u00A0000\u00A0рублей',
	},
	{
		id: 2,
		icon: '',
		title: 'Повышение квалификации',
		text: 'Пройдите бесплатное повышение квалификации по\u00A0инженерной дидактике прямо в\u00A0личном кабинете участника конкурса',
	},
	{
		id: 3,
		icon: '',
		title: 'Признание на\u00A0международном уровне',
		text: 'Продемонстрируйте свои методики ведущим экспертам отрасли и\u00A0коллегам со\u00A0всего мира',
	},
	{
		id: 6,
		icon: '',
		title: '',
		text: 'Развивайтесь, делитесь опытом и\u00A0открывайте новые профессиональные\u00A0возможности.',
	},
	{
		id: 4,
		icon: '',
		title: 'Масштабирование опыта',
		text: 'Лучшие практики будут рекомендованы к\u00A0распространению в\u00A0других вузах страны',
	},
	{
		id: 5,
		icon: '',
		title: 'Обмен опытом',
		text: 'Участие в\u00A0обсуждениях с\u00A0экспертами и\u00A0нетворкинг с\u00A0лучшими преподавателями транспортных вузов',
	},

];
